import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=60db2ee3&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=60db2ee3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60db2ee3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60db2ee3')) {
      api.createRecord('60db2ee3', component.options)
    } else {
      api.reload('60db2ee3', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=60db2ee3&scoped=true", function () {
      api.rerender('60db2ee3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/point/detail.vue"
export default component.exports